import React, { useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { pages } from "../../data/pages";

import UserContext from "../../context/UserContext";

const DrawerItems = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentPagename = searchParams.get("pagename");
  const { isLogged, onLogout, userData } = useContext(UserContext);

  const { name } = userData;
  return (
    <>
      <li className="h-28 w-full flex-row justify-center items-center text-2xl">
        {isLogged ? (
          <>
            <NavLink
              to="/user/profile"
              className="w-full justify-between"
              onClick={props.onClick}
            >
              <i class="fa-solid fa-circle-user text-4xl text-gray-800"></i>
              <h1>{name}</h1>
            </NavLink>
            <NavLink
              className="mr-auto "
              to="/join/signin"
              onClick={() => {
                onLogout();
                props.onClick();
              }}
            >
              Logout
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              to="/join/signin"
              className="hover:text-custom-blue"
              onClick={props.onClick}
            >
              Signin
            </NavLink>
            |
            <NavLink
              to="/join/signup"
              className="hover:text-custom-blue"
              onClick={props.onClick}
            >
              Signup
            </NavLink>
          </>
        )}
      </li>
      <hr />
      {pages.map((item) => (
        <li key={item.id}>
          <NavLink
            to={item.path}
            onClick={props.onClick}
            className={({ isActive }) => `${
              isActive &&
              (currentPagename === item.id || location.pathname === item.path)
                ? "active "
                : " "
            } hover:text-custom-blue
            `}
          >
            {item.text}
          </NavLink>
        </li>
      ))}
    </>
  );
};

export default DrawerItems;
